<template>
    <a-modal
        :visible="isSpinnerModalOpened"
        title="Operation in progress..."
        :closable="false"
        :footer="null"
        centered
        :z-index="1001"
    >
        <a-row class="spinner-box">
            <a-spin size="large" />
        </a-row>
    </a-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            isSpinnerModalOpened: 'modals/isSpinnerModalOpened'
        })
    }
};
</script>
